import title from './elements/title';
import titleWithLine from './elements/title-with-line';
import eyebrow from './elements/eyebrow';
import fadeIn from './elements/fade-in';
import fadeInUp from './elements/fade-in-up';
import fadeInUpText from './elements/fade-in-up_text';
import fadeInDown from './elements/fade-in-down';
import fadeInSlide from './elements/fade-in-slide';
import linkWithIcon from './elements/link-with-icon';

export default [
  title,
  titleWithLine,
  eyebrow,
  fadeIn,
  fadeInUp,
  fadeInUpText,
  fadeInDown,
  fadeInSlide,
  linkWithIcon,
];



// WEBPACK FOOTER //
// ./scripts/animation/animated-elements.js